import React from 'react';
import {Props} from 'react-apexcharts';
import {FormattedMessage, useIntl} from 'react-intl';
import {useDashboardContext} from '../DashboardContext';
import {ChartView} from '../../../../common/components/ui/Chart';
import {mergeClassnames} from '../../../../common/utils';
import {getDashboardChartData} from '../../constants/chartsOptions';
import Column from './DashboardChart.module.scss';

type ComponentCustomClassnames = {
  container: string
  header: string
  spinner: string
};

export interface ChartProps extends Props {
  options?: any,
  header?: string,
  customClassnames?: Partial<ComponentCustomClassnames>;
}

export const DashboardChart = ({
                                 customClassnames = {},
                                 ...rest
                               }: ChartProps) => {
  const intl = useIntl();
  const legend = intl.formatMessage({
    id: 'dashboard-chart-legend',
    defaultMessage: 'Income'
  });

  const {series, categories, loading} = useDashboardContext();
  const lastAmount = series[0];

  return (
    <ChartView
      width={'100%'}
      height={'140'}
      type={'bar'}
      header={
        <div>
          <span>{legend}</span>
          {series.length > 0 && (
            <span>
                <FormattedMessage
                  id={'dashboard-chart-thisMonth'}
                  defaultMessage={'This month {amount} NIS'}
                  values={{amount: `${lastAmount}`}}
                />
              </span>
          )}
        </div>
      }
      options={getDashboardChartData({
        legend,
        series,
        categories
      })}
      customClassnames={mergeClassnames(Column, customClassnames) as ComponentCustomClassnames}
      loading={loading}
      {...rest}
    />
  );
};
